import {useSelector} from 'Provider';
import React from 'react';

import OfferGroup from 'components/Offers/OfferGroup';
import {
  isDatesSelectedSelector,
  offersCurrentMonthSelector,
  offersFilteredSelector,
  offersNextMonthSelector,
  offersNextSevenDaysSelector,
  offersThirdMonthFromCurrentSelector,
  paginatedCurrentMonthOffersSelector,
  paginatedNextMonthOffersSelector,
  paginatedNextSevenDaysSelector,
  paginatedThirdMonthOffersSelector,
  paginationFilteredOffers,
  selectIsListView,
} from 'store/offers/offers.selectors';

const ConnectedOfferGroup: React.FC = () => {
  const {results: offers} = useSelector(offersFilteredSelector);
  const nextSevenDaysOffers = useSelector(offersNextSevenDaysSelector);
  const paginatedSevenDaysOffers = useSelector(paginatedNextSevenDaysSelector);
  const currentMonthOffers = useSelector(offersCurrentMonthSelector);
  const paginatedCurrentMonthOffers = useSelector(
    paginatedCurrentMonthOffersSelector
  );
  const nextMonthOffers = useSelector(offersNextMonthSelector);
  const paginatedNextMonthOffers = useSelector(
    paginatedNextMonthOffersSelector
  );
  const thirdMonthOffers = useSelector(offersThirdMonthFromCurrentSelector);
  const paginatedThirdMonthOffers = useSelector(
    paginatedThirdMonthOffersSelector
  );
  const paginatedFilteredOffers = useSelector(paginationFilteredOffers);
  const isDatesSelected = useSelector(isDatesSelectedSelector);
  const isListView = useSelector(selectIsListView);

  return (
    <OfferGroup
      offers={offers}
      paginatedFilteredOffers={paginatedFilteredOffers}
      nextSevenDaysOffers={nextSevenDaysOffers}
      paginatedSevenDaysOffers={paginatedSevenDaysOffers}
      currentMonthOffers={currentMonthOffers}
      paginatedCurrentMonthOffers={paginatedCurrentMonthOffers}
      nextMonthOffers={nextMonthOffers}
      paginatedNextMonthOffers={paginatedNextMonthOffers}
      thirdMonthOffers={thirdMonthOffers}
      paginatedThirdMonthOffers={paginatedThirdMonthOffers}
      isDatesSelected={isDatesSelected}
      isListView={isListView}
    />
  );
};

export default ConnectedOfferGroup;
